import React, { useEffect } from 'react';
import style from '../css/Contact.module.css';
import NavBar from '../components/navigation/NavBar';
import ContactTop from '../components/common/ContactTop';
import ContactForm from '../components/common/ContactForm';
import Footer from '../components/common/Footer';
import Map from '../components/common/Map';
import BottomNav from '../components/navigation/BottomNav';

function Contact() {
	useEffect(() => {
		window.scrollTo({ top: 0, behavior: 'smooth' });
	}, []);
	return (
		<div>
			<div className="sticky">
				<NavBar />
			</div>
			<ContactTop />
			<Map />
			<Footer />
			<div className="sticky_mob">
				<BottomNav />
			</div>
		</div>
	);
}

export default Contact;
